export class ReadBackendVersionResDto {
    version: string;
}
